import { render, staticRenderFns } from "./student-activity-feed.vue?vue&type=template&id=02f768de&scoped=true"
import script from "./student-activity-feed.vue?vue&type=script&lang=js"
export * from "./student-activity-feed.vue?vue&type=script&lang=js"
import style0 from "./student-activity-feed.vue?vue&type=style&index=0&id=02f768de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f768de",
  null
  
)

export default component.exports